import Big from 'big.js'

/** Decimal places a currency is charged in. */
const CENTS = 2

/**
 * The workspace's standard discount in percent, clamped to 0-100 as the cart summary clamps it: a value
 * outside that range is bad data and would render a negative price.
 */
export const clampDiscountPercentage = (percentage: number | null | undefined): number =>
  Math.min(Math.max(percentage ?? 0, 0), 100)

/**
 * A list price with the workspace discount applied, rounded half-up to the cent like the cart summary, so
 * the price on a card is the price the cart line comes to (QA-648). Null when there is no discount.
 */
export const discountedPrice = (unitPrice: string | number, percentage: number | null | undefined): Big | null => {
  const pct = clampDiscountPercentage(percentage)
  if (pct === 0) return null
  return new Big(unitPrice).times(Big(100).minus(pct).div(100)).round(CENTS, Big.roundHalfUp)
}
